var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 27,
    viewBox: "0 0 23 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_2560_5622)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2866 0H0V21.9403H17.7717V5.48509L12.2866 0Z",
    fill: "#6F6FF1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2560_5622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.91755 15.8996L5.91673 12.9612C5.94233 12.9236 5.97589 12.892 6.01504 12.8688C6.05419 12.8455 6.09797 12.8311 6.14329 12.8267C6.18861 12.8222 6.23435 12.8278 6.27728 12.8429C6.32022 12.8581 6.35929 12.8825 6.39174 12.9145L7.71296 14.209L10.6118 9.66526C10.6405 9.62016 10.6804 9.58324 10.7275 9.55804C10.7747 9.53285 10.8275 9.52024 10.8809 9.52144C10.9344 9.52264 10.9866 9.53761 11.0326 9.56489C11.0785 9.59217 11.1167 9.63085 11.1433 9.67719L14.7451 15.9192C14.7725 15.9665 14.7869 16.0201 14.7869 16.0747C14.7869 16.1293 14.7726 16.183 14.7453 16.2302C14.718 16.2775 14.6787 16.3168 14.6314 16.3441C14.5841 16.3713 14.5304 16.3857 14.4758 16.3856H4.17467C4.11807 16.3857 4.06252 16.3704 4.01401 16.3412C3.9655 16.3121 3.92586 16.2702 3.89938 16.2202C3.87291 16.1702 3.86059 16.1139 3.86377 16.0574C3.86695 16.0009 3.8855 15.9463 3.91742 15.8996H3.91755Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51625 9.24633C4.51625 9.66199 4.68137 10.0606 4.97528 10.3545C5.26919 10.6484 5.66782 10.8136 6.08348 10.8136C6.49913 10.8136 6.89776 10.6484 7.19167 10.3545C7.48559 10.0606 7.6507 9.66199 7.6507 9.24633C7.6507 8.83068 7.48559 8.43205 7.19167 8.13814C6.89776 7.84423 6.49913 7.67911 6.08348 7.67911C5.66782 7.67911 5.26919 7.84423 4.97528 8.13814C4.68137 8.43205 4.51625 8.83068 4.51625 9.24633Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7715 5.48508L12.2864 -1.09699e-05C12.2864 3.02932 14.7422 5.48508 17.7715 5.48508Z",
    fill: "#B5C8FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_2560_5622",
    x: 0,
    y: -1,
    width: 17.7715,
    height: 23.9404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2560_5622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_2560_5622",
    result: "effect2_innerShadow_2560_5622"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2560_5622",
    x: 2.86328,
    y: 6.67911,
    width: 19.9238,
    height: 19.7065,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2560_5622"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2560_5622",
    result: "effect2_dropShadow_2560_5622"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2560_5622",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.6a2cda72484a946c7b76c647696d2d34.svg";
export { ForwardRef as ReactComponent };